import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_SURPRISE } from '@/modules/surprise/router';
import { surpriseService } from '@/services/surprise';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useSurpriseCategoryEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: StringUtils.toNumber(route.params.id),
        name: '',
        isPublished: false
    });

    const validations = {
        name: { required },
        isPublished: { required }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => surpriseService.category.get(model.id),
        onSuccess: ({ data }) => {
            data.startTime = new Date(data.startTime);
            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_SURPRISE.CATEGORY.INDEX })
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () => surpriseService.category.update(model.id, model.name, model.isPublished),
            onSuccess: () => router.push({ name: ROUTE_NAME_SURPRISE.CATEGORY.INDEX })
        }),
        remove: crudAction.confirmAndRemove({
            request: () => surpriseService.category.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_SURPRISE.CATEGORY.INDEX })
        })
    };

    return { model, v$, fetch, actions };
}
